export const IconLock = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#IconLock_svg__a)">
        <path d="M20.488 12.043c-.006-1.184-.718-2.127-1.8-2.45-.494-.146-1.004-.112-1.506-.09-.29.012-.343-.09-.336-.36a48 48 0 0 0 .004-2.094c-.026-1.54-.55-2.842-1.694-3.873-1.352-1.215-3.583-1.54-5.195-.732-1.877.942-2.77 2.516-2.817 4.633q-.025 1.064.005 2.124c.007.258-.078.314-.304.297-.252-.018-.505-.005-.758-.003-1.53.005-2.585 1.092-2.586 2.67q-.002 3.577 0 7.155c0 .282.03.56.107.832.328 1.14 1.249 1.842 2.442 1.845 1.983.006 3.964.002 5.946.002s3.963.004 5.945-.002c1.453-.003 2.536-1.07 2.548-2.547.018-2.47.015-4.937 0-7.406zM9.01 6.569c.157-1.41 1.216-2.493 2.59-2.65 1.165-.135 2.119.253 2.837 1.212.415.553.57 1.206.589 1.888.02.749-.004 1.499.01 2.249.003.21-.076.23-.245.23-.94-.008-1.879-.005-2.818-.005-.91 0-1.82-.006-2.728.005-.21.003-.3-.027-.29-.28.04-.882-.044-1.767.055-2.649m8.891 13.553q-2.942.002-5.883 0H6.166c-.66 0-.843-.19-.843-.87V12.19c0-.614.2-.82.8-.82H17.89c.577 0 .782.21.782.807q.003 3.577 0 7.155c0 .572-.21.789-.769.789" />
      </g>
      <defs>
        <clipPath id="IconLock_svg__a">
          <path fill="#fff" d="M3.5 2h17v20h-17z" />
        </clipPath>
      </defs>
    </svg>
  );
};
